module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticePointingDiagonal-01628f9248ed94db92bf66a6d3f2ca75.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticePointingDiagonal.png
// module id = 884
// module chunks = 2